/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Export_FileInputs */

const en_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export File`)
};

const fr_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter un fichier`)
};

const de_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportdatei`)
};

const it_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta file`)
};

const ru_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт файла`)
};

const es_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar archivo`)
};

const zh_cn2_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出文件`)
};

const ja_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルのエクスポート`)
};

const hi_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात फ़ाइल`)
};

const pt_pt2_shortcut_keys_name_export_file = /** @type {(inputs: Shortcut_Keys_Name_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de exportação`)
};

/**
* | output |
* | --- |
* | "Export File" |
*
* @param {Shortcut_Keys_Name_Export_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_export_file = /** @type {((inputs?: Shortcut_Keys_Name_Export_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Export_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_export_file(inputs)
	if (locale === "de") return de_shortcut_keys_name_export_file(inputs)
	if (locale === "it") return it_shortcut_keys_name_export_file(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_export_file(inputs)
	if (locale === "es") return es_shortcut_keys_name_export_file(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_export_file(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_export_file(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_export_file(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_export_file(inputs)
	return en_shortcut_keys_name_export_file(inputs)
});